import { getPaymentUrl } from "@api/index";
import Button from "@components/_Revamp/Button";
import { styled } from "@linaria/react";
import { trackOnCTA } from "@pages/CCP/Helpers/analyticsHelper";
import { useAvivaDispatch, useAvivaSelector } from "@redux/hook";
import { ROUTE_PATH } from "@static/route-paths";
import { SCREEN_SIZE } from "@static/screen-size";
import { LoadingScreen } from "@utils/helpers";
import React, { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { themeDefault } from "src/theme-revamp";

function ConfirmButton() {
  const formData = useAvivaSelector((state) => state.cancerCoverStep6.payment);
  const arcCode = useAvivaSelector(state=>state.cancerCoverStep6.arcCode)
  const promoCode = useAvivaSelector(
      (state) => state.cancerCoverStep6.promoCode
    );
  const customerId = useAvivaSelector(
    (state) => state.cancerCoverStep4.myInfo.customerId
  );
  const transactionId = useAvivaSelector(
    (state) => state.cancerCoverStep1.transactionId || ""
  );
  const payment = useAvivaSelector((state) => state.cancerCoverStep6.payment);
  const [disable, setDisabled] = useState(true);

  const history = useHistory();
  const onClickHandler = async function fetch() {
    const data =
      payment.creditCard[
        payment.isPayingSelf === "yes" ? "myself" : "thirdParty"
      ];
      const trackingCodeJson = {
        ecid:"",pid:"",pm: promoCode, arc:arcCode,formType:""}
    try {
      LoadingScreen();
      const payload = {
        customerId,
        transactionId,
        trackingCodeJson,
        paymentDetails: {
          payingYourself: payment.isPayingSelf === "yes" ? "Y" : "N",
          payeeDetails: {
            fullName: data?.name || null,
            nricFinPassportNo: data?.nric || null,
            relationshipStatus: data?.relationship || null,
            policyReason: data?.reason || null,
            bank: data?.bank || null,
          },
        },
      };
      const url = await getPaymentUrl(payload, "CCP");
      trackOnCTA({
        ctaText:"Confirm Payment",
        ctaType:"qb:link"
      })
      window.open(url.data, "_self");
    } catch (e) {
      history.push(ROUTE_PATH.CANCER_COVER_CONTACT_US);
    } finally {
      LoadingScreen(false);
    }
  };

  useEffect(() => {
    if (payment.isPayingSelf) {
      const data =
        payment.creditCard &&
        payment.creditCard[
          payment.isPayingSelf === "yes" ? "myself" : "thirdParty"
        ];
      if (!data) return;
      // myself
      if (
        payment.isPayingSelf === "yes" &&
        data.name &&
        data.nric &&
        /^[S|T|F|G|M]{1}[0-9]{7}[A-Za-z]{1}$/.test(data.nric || "") &&
        data.bank
      ) {
        setDisabled(false);
        return;
      } else if (
        payment.isPayingSelf === "no" &&
        data.name &&
        data.nric &&
        /^[S|T|F|G|M]{1}[0-9]{7}[A-Za-z]{1}$/.test(data.nric || "") &&
        data.bank &&
        data.relationship &&
        (data.relationship === "Others"? !!data.reason : true )
      ) {
        setDisabled(false);
        return;
      }
    }
    setDisabled(true);
  }, [payment]);

  return (
    <>
      <BtnContainer>
        <Button
          label={
            // formData.paymentMethod === "cc"
            //   ? formData.isPayingSelf === "yes" ?"Proceed to payment" : "Proceed to payment" : "Proceed to payment"
             "Proceed to payment"
          }
          disabled={disable}
          bgColor={themeDefault.colors.primary}
          margin={"64px auto"}
          onClick={onClickHandler}
        />
      </BtnContainer>
    </>
  );
}

export default ConfirmButton;

const BtnContainer = styled.div`
  button {
    margin-bottom: 16px;
  }
  button:disabled {
    background-color: #d4bfd7;
    color: white;
  }
  & > span {
    font-size: 12px;
    font-weight: 500;
    color: #434343;
    line-height: 19.2px;
  }

  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    button {
      max-width: 227px;
    }
  }
`;
